var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _rect5, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMkv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#17A2B8"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1676 41.1818H50.6449L71.3722 91.7727H72.1903L92.9176 41.1818H108.395V111H96.2585V63.0341H95.6108L76.3153 110.795H67.2472L47.9517 62.9318H47.304V111H35.1676V41.1818ZM122.168 111V41.1818H134.815V73.2614H135.668L162.906 41.1818H178.349L151.349 72.5114L178.588 111H163.384L142.554 81.0682L134.815 90.2045V111H122.168ZM196.477 41.1818L214.648 96.1364H215.364L233.5 41.1818H247.409L222.795 111H207.182L182.602 41.1818H196.477Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 236,
    width: 178,
    height: 156,
    fill: "#FAFAFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M148.457 235.668L167.728 275.251H201.582L182.311 235.668H205.488L224.759 275.251H258.613L239.342 235.668H262.52L281.79 275.251H315.645L296.374 235.668H325.54C329.707 235.668 333.353 237.23 336.478 240.355C339.603 243.48 341.165 247.126 341.165 251.293V386.71C341.165 390.876 339.603 394.522 336.478 397.647C333.353 400.772 329.707 402.335 325.54 402.335H148.457C144.29 402.335 140.645 400.772 137.52 397.647C134.395 394.522 132.832 390.876 132.832 386.71V251.293C132.832 247.126 134.395 243.48 137.52 240.355C140.645 237.23 144.29 235.668 148.457 235.668ZM148.457 290.876V386.71H325.54V290.876H148.457ZM148.457 290.876V386.71V290.876Z",
    fill: "#17A2B8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_960",
    x: 23.168,
    y: 41.1836,
    width: 228.242,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_960",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkv);
export default __webpack_public_path__ + "static/media/mkv.1d980f583aa02c264a4fde287ca85795.svg";
export { ForwardRef as ReactComponent };